import React from 'react';
import _ from 'underscore';

import {FeatureFlags} from '~commonInfra/featureFlags/FeatureFlags';
import {ExtensionsSettingsCoordinator} from '~src/settings/extensions-settings/ExtensionsSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';

import {RouterError} from '../../../../../bootstrap/routerHelpers/RouterError';
import {SessionManagementService} from '../../../../../sessionManagement/SessionManagementService';
import { ExtensionsSettingsSubspaceState, getData } from '../../../../extensions-settings/ExtensionsSettingsSubspaceShared';

interface ExtensionsServerSettingsSubspaceOwnProps {
  readonly server: SessionManagementService;
}

export class ExtensionsServerSettingsSubspaceComponent extends React.PureComponent<ExtensionsServerSettingsSubspaceOwnProps, ExtensionsSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: ExtensionsSettingsSubspaceState = {
    isServerPage: true,
    hasDataToRender: false,
    hasError: false,
    dashExtServerSettings: undefined,
    dashExtSiteSettings: undefined,
    extsvcServerSettings: undefined,
    analyticsExtensionsServerSettings: undefined,
    analyticsExtensionsSiteSettings: undefined,
    siteSettingsForSiteAdmin: undefined,
  };

  public constructor(props: ExtensionsServerSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
    };
  }

  public componentDidMount() {
    getData(
      (newState) => { this.updateState(newState as ExtensionsSettingsSubspaceState); },
      () => { this.updateState({hasError: true}); }
    );
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if (!_.isUndefined(this.state.dashExtServerSettings)
      && !_.isUndefined(this.state.dashExtSiteSettings)
      && (!_.isUndefined(this.state.siteSettingsForSiteAdmin) || !FeatureFlags.prepExtensionsEinstein)
      && (!_.isUndefined(this.state.analyticsExtensionsSiteSettings))
      && (!_.isUndefined(this.state.analyticsExtensionsServerSettings))
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }

    return (
      <div className={subspaceStyle}>
        <ExtensionsSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof ExtensionsSettingsSubspaceState>(newState: Pick<ExtensionsSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }
}
